import {
  makeStyles,
  Typography,
  Box,
  Divider,
  Button,
  FormControlLabel,
} from "@material-ui/core";
import Field from "../field";
import { useForm } from "react-hook-form";
import { useEffect } from "react";

export default function BasalCategoryForm({ onSubmit, isEdit, data }) {
  const { register, handleSubmit, errors, reset, trigger } = useForm();
  const classes = useStyles();
  async function restoreRefillCategory() {
    if (!data) return;
    // console.log(data);

    reset({
      name: data.name,
      refillTo: String(data.refillTo),
    });
    setTimeout(() => {
      trigger(["name", "refillTo"]);
    }, 0);
  }
  useEffect(() => {
    if (isEdit) restoreRefillCategory();
  }, [data]);

  return (
    <>
      <Box
        className={classes.section_form}
        component="form"
        style={isEdit && !data ? { userSelect: "none", opacity: "0.8" } : {}}
        onSubmit={handleSubmit((data) => {
          const dataToSubmit = {
            name: data.name,
            refillTo: parseInt(data.refillTo),
          };
          onSubmit(dataToSubmit);
        })}
      >
        <Typography variant="h6">Categoria</Typography>
        <Divider style={{ marginBottom: 12, marginTop: 6 }} />
        <Box className={classes.form_basal_fields}>
          <Field
            id="name-category"
            placeholder="Nombre de categoria"
            label="Nombre"
            name="name"
            inputRef={register({
              required: "Nombre requerido",
              minLength: {
                value: 5,
                message: "El nombre debe ser de al menos 5 letras",
              },
            })}
            error={errors[`name`] ? true : false}
            helperText={errors[`name`] ? errors[`name`].message : ""}
          />
          <Field
            id="qty"
            placeholder="0"
            label="Cantidad de auto relleno"
            type="number"
            name="refillTo"
            inputRef={register({
              required: "Cantidad requerida",
              min: {
                value: 0,
                message: "Cantidad mayor o igual a 0",
              },
            })}
            inputProps={{ min: 0 }}
            error={errors[`refillTo`] ? true : false}
            helperText={errors[`refillTo`] ? errors[`refillTo`].message : ""}
          />
          <Button
            className={classes.submit_button}
            color="primary"
            variant="contained"
            type="submit"
            style={{ textTransform: "none" }}
          >
            Guardar
          </Button>
        </Box>
      </Box>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  form_basal_fields: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  submit_button: {
    width: "100%",
    marginTop: theme.spacing(2),
  },
  section_form: {
    margin: theme.spacing(2),
  },
}));
